import React from "react";
import { Chip, HoverPopup } from "../../../../../components";

const HoverInfo = () => {
  return (
    <div className="my-5">
      <HoverPopup
        content={
          <ul className="space-y-1">
            <li className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-orange-500"></span>
              Initiated - 7
            </li>
            <li className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-orange-500"></span>
              Responded - 1
            </li>
            <li className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-green-500"></span>{" "}
              Verified - 0
            </li>
            <li className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-red-500"></span> Rejected
              - 0
            </li>
            <li className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-green-500"></span> Wish
              To Discuss - 0
            </li>
          </ul>
        }
      >
        <Chip
          label="(8/9)"
          color="primary"
          size="xs"
          className="!bg-primary-100 rounded-xl !p-1"
        />
      </HoverPopup>
    </div>
  );
};

export default HoverInfo;
